import { IfAbility } from '@efdigital/ll-addon-auth';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';

import { HelpButton } from './help-button.gts';
interface HeaderSignature {
  Element: HTMLElement;
}

const Header: TemplateOnlyComponent<HeaderSignature> = <template>
  <div class="navbar navbar-expand bg-white shadow-sm py-2" ...attributes>
    <div class="container-fluid container-xl">
      <LinkTo class="navbar-brand fw-bold" @route="index">Admin<span
          class="text-hultashridge-teal"
        >·2</span></LinkTo>
      <ul class="navbar-nav me-auto fs-6 fw-semibold text-nowrap">
        <li class="nav-item">
          <LinkTo
            class="nav-link"
            aria-current="page"
            @route="index"
          >Home</LinkTo>
        </li>
        <li class="nav-item">
          <LinkTo class="nav-link" @route="programs">Programs</LinkTo>
        </li>
        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Coaching
          </a>
          <ul class="dropdown-menu">
            <li>
              <LinkTo
                class="dropdown-item"
                @route="coaching.configs"
              >Configurations</LinkTo>
            </li>
            <li>
              <LinkTo
                class="dropdown-item"
                @route="coaching.coaches"
              >Coaches</LinkTo>
            </li>
            <li>
              <LinkTo
                class="dropdown-item"
                @route="coaching.sessions"
              >Sessions</LinkTo>
            </li>
          </ul>
        </li>
        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Library
          </a>
          <ul class="dropdown-menu">
            <li>
              <LinkTo
                class="dropdown-item"
                @route="library.media-images"
              >Images</LinkTo>
            </li>
            <li>
              <LinkTo
                class="dropdown-item"
                @route="library.clients"
              >Clients</LinkTo>
            </li>
            <IfAbility @ability="clients:users" @atLeast="viewer">
              <:if>
                <li>
                  <LinkTo
                    class="dropdown-item"
                    @route="library.users"
                  >Users</LinkTo>
                </li>
              </:if>
            </IfAbility>
            <li>
              <LinkTo
                class="dropdown-item"
                @route="library.folders"
              >Files</LinkTo>
            </li>
          </ul>
        </li>
      </ul>
      <HelpButton class="btn btn-secondary btn-sm px-3" />
    </div>
  </div>
</template>;

export default Header;
